import { render, staticRenderFns } from "./pasetDetail.vue?vue&type=template&id=106d0444&"
import script from "./pasetDetail.vue?vue&type=script&lang=js&"
export * from "./pasetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports